import styled from "@emotion/styled";

export const Input = styled.input`
  font-size: 14px;
  padding: 10px;
  border: 1px solid ${({ error }) => (error ? 'red' : '#ddd')};
  box-sizing: border-box;
  height: 40px;
  width: 100%;
`;

